import React, { useEffect, useState } from 'react'
import { superAxiosRequest } from 'axiosApi'
import PageHeader from 'components/UI/PageHeader/PageHeader'
import styles from './TypeOfTraining.module.scss'
import { HeaderAddButton } from 'components/UI/SuperButton/SuperButton'
import asideModalStore from 'Stores/asideModalStore'
import swal from 'sweetalert'
import { Type } from './Type/Type'
import AddTypeOfTraining from '../../../ContentBox/Global/GlobalModalSingle/templates/CRM/AddTypeOfTraining/AddTypeOfTraining'

export const TypeOfTraining = ({ translate }) => {
  const [types, setTypes] = useState([])

  const fetchLearningType = async () => {
    try {
      const { data } = await superAxiosRequest({
        link: `settings/project_settings/deal_education_type_choices`,
        method: 'get',
        crm: true,
      })
      if (data?.value?.choices) {
        setTypes(data.value.choices)
      }
    } catch (error) {
      console.error('Ошибка загрузки причин:', error)
    }
  }

  useEffect(() => {
    fetchLearningType()
  }, [])

  const updateReasons = async (updatedChoices) => {
    try {
      const payload = {
        value: {
          choices: updatedChoices,
        },
      }

      const response = await superAxiosRequest(
        {
          link: `settings/project_settings/deal_education_type_choices`,
          method: 'put',
          crm: true,
        },
        payload,
      )

      await fetchLearningType()
    } catch (error) {
      console.error('Полная ошибка:', {
        message: error.message,
        response: error.response?.data,
        config: error.config,
      })
      throw error
    }
  }

  const addType = () => {
    const ms = {
      modalBodyComponent: () => <AddTypeOfTraining />,
      button: 'Save',
      link: 'settings/project_settings/deal_education_type_choices',
      title: 'Add type of training',
      isCenter: true,
      is_put: true,
      crm: true,
      onBeforeSubmit: (data) => {
        const newReason = {
          id: types.length + 1,
          name: data.value,
        }
        return {
          value: {
            choices: [...types, newReason],
          },
        }
      },
      onSubmitSuccess: fetchLearningType,
      valid: { value: 'required' },
    }
    asideModalStore.activity(ms)
  }

  const editType = (reason) => {
    const ms = {
      modalBodyComponent: () => (
        <AddTypeOfTraining initialValue={reason?.name} />
      ),
      button: 'Сохранить',
      link: 'settings/project_settings/deal_education_type_choices',
      title: 'Edit the type',
      isCenter: true,
      is_put: true,
      crm: true,
      onBeforeSubmit: (data) => {
        const updated = types.map((r) =>
          r.id === reason.id ? { ...r, name: data.value } : r,
        )
        return {
          value: {
            choices: updated,
          },
        }
      },
      onSubmitSuccess: fetchLearningType,
      valid: { value: 'required' },
    }
    asideModalStore.activity(ms)
  }

  const deleteType = (typeId) => {
    swal({
      title: 'Вы уверены?',
      text: 'После удаления тип нельзя будет восстановить.',
      icon: 'warning',
      buttons: {
        cancel: {
          text: 'Отмена',
          value: null,
          visible: true,
        },
        confirm: {
          text: 'Удалить',
          value: true,
          className: 'swal-button--danger',
        },
      },
      dangerMode: true,
    }).then(async (willDelete) => {
      if (willDelete) {
        try {
          const updated = types.filter((r) => r?.id !== typeId)
          await updateReasons(updated)
          swal('Успешно!', 'Тип был удален.', 'success')
        } catch (error) {
          swal('Ошибка!', 'Не удалось удалить тип.', 'error')
          console.error('Ошибка удаления:', error)
        }
      }
    })
  }

  const action = (actionType, e, items) => {
    const actions = new Map([
      ['edit_type', () => editType(items)],
      ['delete_type', () => deleteType(items?.id)],
    ])
    return actions.get(actionType)?.()
  }

  const menu = [
    { name: translate.edit, action: 'edit_type' },
    { name: translate.delete, action: 'delete_type' },
  ]

  return (
    <div className={styles.reasonsContainer}>
      <div className={styles.header}>
        <PageHeader title={'Тип обучения'} />
        <div className={styles.settingsLocalization__box}>
          <HeaderAddButton title={'Добавить тип'} onClick={addType} />
        </div>
      </div>
      {types.length === 0 ? (
        <div className={styles.noReasons}>There are no added types</div>
      ) : (
        types.map((type, index) => (
          <Type
            key={type.id + index}
            type={type}
            action={action}
            index={index}
            menu={menu}
          />
        ))
      )}
    </div>
  )
}
